import { createContext } from "react";

const municipalityContext = createContext();

export default municipalityContext;
